import React, { useState } from 'react'
import { Mail, Phone } from 'lucide-react'

const contactDetails = [
  {
    icon: Mail,
    label: "Email",
    value: "kdpspackages@gmail.com",
    href: "mailto:kdpspackages@gmail.com",
  },
  {
    icon: Phone,
    label: "Phone",
    value: "(876) 393-2065",
    href: "tel:+18763932065",
  },
]

export function Contact() {
  const [name, setName] = useState("")
  const [email, setEmail] = useState("")
  const [subject, setSubject] = useState("")
  const [message, setMessage] = useState("")

  const phoneNumber = "18763932065"

  const onSendToWhatsApp = () => {
    const lines = [
      "New message from KDPS website:",
      name ? `Name: ${name}` : null,
      email ? `Email: ${email}` : null,
      subject ? `Subject: ${subject}` : null,
      message ? `Message: ${message}` : null,
    ].filter(Boolean)

    const text = encodeURIComponent(lines.join("\n"))
    window.open(`https://wa.me/${phoneNumber}?text=${text}`, "_blank", "noopener,noreferrer")
  }

  return (
    <section
      id="contact"
      className="bg-white py-16 sm:py-20 lg:py-28"
    >
      <style>{`
        .contact-tag {
          display: inline-block;
          font-size: 10px;
          font-weight: 600;
          letter-spacing: 0.15em;
          text-transform: uppercase;
          padding: 4px 12px;
          border: 1px solid #d4d4d4;
          border-radius: 999px;
          color: #666;
        }

        .contact-divider {
          width: 100%;
          height: 1px;
          background: #efefef;
        }

        .contact-field {
          display: flex;
          flex-direction: column;
          gap: 6px;
        }

        .contact-label {
          font-size: 11px;
          font-weight: 600;
          letter-spacing: 0.1em;
          text-transform: uppercase;
          color: #999;
        }

        .contact-input {
          width: 100%;
          padding: 13px 16px;
          border: 1px solid #e8e8e8;
          border-radius: 8px;
          font-size: 14px;
          font-family: inherit;
          color: #111;
          background: #fafaf9;
          outline: none;
          transition: border-color 0.2s, box-shadow 0.2s;
          box-sizing: border-box;
        }

        .contact-input:focus {
          border-color: #111;
          background: white;
          box-shadow: 0 0 0 3px rgba(0,0,0,0.04);
        }

        .contact-input::placeholder {
          color: #ccc;
        }

        .contact-submit {
          width: 100%;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          gap: 8px;
          background: #111;
          color: white;
          border: none;
          border-radius: 8px;
          padding: 15px 24px;
          font-size: 14px;
          font-weight: 600;
          font-family: inherit;
          cursor: pointer;
          transition: opacity 0.2s;
        }

        .contact-submit:hover {
          opacity: 0.75;
        }

        .contact-info-row {
          display: flex;
          align-items: flex-start;
          gap: 14px;
          padding: 16px 0;
          border-bottom: 1px solid #f0f0f0;
        }

        .contact-info-row:last-child {
          border-bottom: none;
        }

        .contact-info-icon {
          width: 36px;
          height: 36px;
          border-radius: 8px;
          background: #f5f3f0;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-shrink: 0;
        }

        .contact-info-label {
          font-size: 10px;
          font-weight: 600;
          letter-spacing: 0.12em;
          text-transform: uppercase;
          color: #bbb;
          margin-bottom: 2px;
        }

        .contact-info-value {
          font-size: 14px;
          color: #333;
          font-weight: 500;
          text-decoration: none;
          transition: color 0.2s;
        }

        a.contact-info-value:hover {
          color: #111;
        }
      `}</style>

      <div className="max-w-7xl mx-auto px-5 sm:px-8 lg:px-16">

        <div className="contact-divider mb-12" />

        {/* Header */}
        <div className="mb-12">
          <p className="contact-tag mb-4">Contact</p>
          <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-4">
            <h2 style={{
              fontWeight: 700,
              fontSize: "clamp(26px, 3.5vw, 44px)",
              lineHeight: 1.15,
              color: "#111",
            }}>
              Let's build something{" "}
              <span style={{ fontFamily: "'Playfair Display', Georgia, serif", fontStyle: "italic", fontWeight: 400, color: "#b91c1c" }}>together</span>
            </h2>
            <p style={{ fontSize: "13px", color: "#999", maxWidth: "280px", lineHeight: 1.7, textAlign: "right" }}
              className="hidden sm:block">
              Have a project in mind? Get in touch and we'll make it happen.
            </p>
          </div>
        </div>

        {/* Body — form left, contact info right */}
        <div className="grid lg:grid-cols-[1.4fr_0.6fr] gap-12 lg:gap-20 items-start">

          {/* Left — form */}
          <div style={{ display: "flex", flexDirection: "column", gap: "18px" }}>
            <div className="grid sm:grid-cols-2 gap-4">
              <div className="contact-field">
                <label className="contact-label">Name</label>
                <input
                  type="text"
                  className="contact-input"
                  placeholder="Your name"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                />
              </div>
              <div className="contact-field">
                <label className="contact-label">Email</label>
                <input
                  type="email"
                  className="contact-input"
                  placeholder="your@email.com"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
              </div>
            </div>

            <div className="contact-field">
              <label className="contact-label">Subject</label>
              <input
                type="text"
                className="contact-input"
                placeholder="What's this about?"
                value={subject}
                onChange={(e) => setSubject(e.target.value)}
              />
            </div>

            <div className="contact-field">
              <label className="contact-label">Message</label>
              <textarea
                className="contact-input"
                rows={6}
                placeholder="Tell us about your project..."
                style={{ resize: "vertical" }}
                value={message}
                onChange={(e) => setMessage(e.target.value)}
              />
            </div>

            <button type="button" className="contact-submit" onClick={onSendToWhatsApp}>
              Send Message
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                <path d="M7 17L17 7M17 7H7M17 7v10" />
              </svg>
            </button>
          </div>

          {/* Right — contact details */}
          <div>
            <p style={{ fontSize: "13px", color: "#999", lineHeight: 1.8, marginBottom: "24px" }}>
              Prefer to reach out directly? Use any of the channels below and we'll get back to you as soon as possible.
            </p>

            <div className="contact-divider mb-4" />

            {contactDetails.map(({ icon: Icon, label, value, href }) => (
              <div key={label} className="contact-info-row">
                <div className="contact-info-icon">
                  <Icon size={15} color="#888" strokeWidth={2} />
                </div>
                <div>
                  <div className="contact-info-label">{label}</div>
                  {href ? (
                    <a href={href} className="contact-info-value">{value}</a>
                  ) : (
                    <span className="contact-info-value">{value}</span>
                  )}
                </div>
              </div>
            ))}
          </div>

        </div>

        <div className="contact-divider mt-12" />

      </div>
    </section>
  )
}